import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const Footer = ({ businessInfo }) => {
  return (
    <footer className="bg-chocolate-dark py-8 px-6 text-white/60">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <div className="text-white font-bold text-xl mb-1">{businessInfo.name}</div>
            <div>{businessInfo.tagline}</div>
          </div>
          <div className="flex items-center space-x-6">
            <a href={businessInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={businessInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
          <div className="text-center md:text-right">
            © 2025 Brazolovers. Todos los derechos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
